import { Container, Grid, Paper, withStyles, Button } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import UserTable from '../table/user';
import UserForm from '../forms/users';
import PersonAddIcon from '@material-ui/icons/PersonAdd';

const styles = (theme: any) => ({
    root: { flrexGrow: 1, paddingTop: theme.spacing(4), paddingBottom: theme.spacing(4), maxWidth: 1300, margin: 'auto'},
    paper: { padding: theme.spacing(2), textAlign: 'center' as any, color: theme.palette.text.secondary }
});

interface Props {
    classes: any;
    currentUser: any;
}

interface State {
    isEditing: boolean;
    user: any;
    authorize: boolean;
}


class Users extends Component<Props, State> {
    state: State = { isEditing: false, user: null, authorize: false };
    constructor(props: Props) {
        super(props);
        this.editHandler = this.editHandler.bind(this);
        this.reset = this.reset.bind(this);
    }

    public editHandler(user: any, authorize?: any) {
        this.setState({ ...this.state, isEditing: true, user: user, authorize: authorize });
    }

    public reset() {
        this.setState({ ...this.state, isEditing: false, authorize: false });
    }

    public render() {
        const { classes, currentUser } = this.props;
        const { user, isEditing, authorize } = this.state;

        return (
            <div>
                {currentUser.role !== 'admin' ?
                    <Container className={classes.root}>
                        <strong>You do not have the right permissions to render this view...</strong>
                    </Container>
                    :
                    <Container className={classes.root} maxWidth="lg">
                        <h2>Users</h2>
                        <Grid container spacing={3} direction="row" justify="flex-start" >
                            <Grid item xs={12} md={6}>
                                {isEditing ?
                                    <Paper className={classes.paper}>
                                        <UserForm edit={isEditing} current={user} action={this.reset} authorized={authorize} />
                                    </Paper>
                                    :
                                    <Grid container spacing={2}>
                                        <Grid item>
                                            <Button variant="contained" onClick={() => this.editHandler(null)} color="primary" startIcon={<PersonAddIcon />}>Add User</Button>
                                        </Grid>
                                        <Grid item>
                                            <Button variant="contained" onClick={() => this.editHandler(null, true)} color="secondary" startIcon={<PersonAddIcon />}>Authorize SSO User</Button>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <UserTable edit={this.editHandler} />
                            </Grid>
                        </Grid>
                    </Container>
                }
            </div>

        );
    }
}
const mapProps = (app: any) => ({ users: app.rootReducer.users, currentUser: app.rootReducer.user });
const mapDispatch = (dispatch: Dispatch) => ({
    addUser: (data: any) => console.log('User will be added', data),
    updateUser: (data: any) => console.log('User will be updated', data)
});
export default connect(mapProps, mapDispatch)(withStyles(styles)(Users));